import styled, {
 keyframes
} from 'styled-components';
import {
 useContext
} from 'react';
import {
 Context
} from 'shared/context/GlobalState';
import {
 BsCheckCircle
} from 'react-icons/bs';
import {
 LuAlertCircle
} from 'react-icons/lu';
import {
 BiError
} from 'react-icons/bi';

// Define allowed notification types
type NotificationType = 'danger' | 'success' | 'warning';

// Props interface for styled components
interface TypeProps {
  $type: NotificationType;
}

const NotifcationContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 0;
  right: 0;
  top: 0;
  margin: auto;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  width: 500px;
  padding: 5px;
  height: auto;
  max-height: 400px;
  overflow: hidden;
  gap: 10px;
  z-index: 10000;
`;

const AnimationEffect = keyframes`
  from {
    transform: translateY(-80px);
  }
  to {
    transform: translateY(0px);
  }
`;

const NotficationContent = styled.div<TypeProps>`
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
  width: 400px;
  background-color: ${({
 $type
}) =>
    $type === 'danger' ? '#ED4545' : $type === 'success' ? '#DFF8F3' : '#fff'};
  padding: 10px;
  border: ${({
 $type
}) =>
    $type === 'danger'
      ? 'none'
      : $type === 'success'
      ? '1px solid #7EA49B'
      : '1px solid #aa4b07'};
  border-radius: 5px;
  animation: ${AnimationEffect} 0.2s ease-in;
`;

const IconContainer = styled.div<TypeProps>`
  display: flex;
  align-items: center;
  color: ${({
 $type
}) =>
    $type === 'danger' ? '#fff' : $type === 'success' ? '#294E4B' : '#bd5c17'};
`;

const MessageContainer = styled.div<TypeProps>`
  word-wrap: break-word;
  flex-grow: 1;
  max-width: 350px;
  min-height: 20px;
  max-height: 80px;
  overflow: hidden;
  color: ${({
 $type
}) =>
    $type === 'danger' ? '#fff' : $type === 'success' ? '#294E4B' : '#bd5c17'};
`;

const NotificationMessage = styled.span`
  font-size: 14px;
  font-weight: 500;
  word-wrap: break-word;
`;

export default function Notifcation() {
    const {
        notificationStatus
    } = useContext(Context);

    function routitIcons(type: NotificationType) {
        if (type === 'danger') return <BiError color="#fff" />;
        else if (type === 'success') return <BsCheckCircle color="#0DBE5E" />;
        else return <LuAlertCircle color="#ca6a25" />;
    }

    return (
        <NotifcationContainer>
            {notificationStatus?.map((notification, i) => (
                <NotficationContent key={i} $type={notification.type as NotificationType}>
                    <IconContainer $type={notification.type as NotificationType}>
                        {routitIcons(notification.type as NotificationType)}
                    </IconContainer>
                    <MessageContainer $type={notification.type as NotificationType}>
                        <NotificationMessage>{notification.message}</NotificationMessage>
                    </MessageContainer>
                </NotficationContent>
            ))}
        </NotifcationContainer>
    );
}
